// extracted by mini-css-extract-plugin
module.exports = {"ProfileDropdown":"ProfileDropdown_ProfileDropdown__25deB"};